import { merge } from "lodash";
import { generateEndpoints, prefix } from "../helpers";
/**
 * This is the reource identifier
 * Everything will be under users.get, users.getAll, users.create, users.createAndSendEmail etc...
 */
const namespace = "attachments";

const nameSpace = merge({}, generateEndpoints(namespace), {
  get: { },

  post: {  
    getDocumentsList: (data) => [`${prefix}/platform/attachment/attachments/`, 
      { entity : data.entity, 
        entityType : data.entityType
      }]
  },
  put: { },
  
  delete: { }
})


export default nameSpace;
